import React from 'react';
import * as Ui from './styles';

function handleEvent(evt, callback) {
  if (callback) {
    callback(evt);
  }
}

const ZoomButton = ({
  onZoomIn,
  onZoomOut,
  style,
  disableZoomIn = false,
  disableZoomOut = false,
  theme,
}) => (
  <Ui.ZoomButton style={style} theme={theme}>
    <button
      type="button"
      onClick={(ev) => handleEvent(ev, onZoomIn)}
      disabled={disableZoomIn}
    >
      <svg
        width="20"
        height="21"
        viewBox="0 0 25 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.7031 10.6953H24.2188V14.7969H14.7031V25.5781H10.3438V14.7969H0.828125V10.6953H10.3438V0.734375H14.7031V10.6953Z"
          fill={disableZoomIn ? theme.disabled : theme.buttons}
        />
      </svg>
    </button>
    <div className="divider" />
    <button
      type="button"
      onClick={(ev) => handleEvent(ev, onZoomOut)}
      disabled={disableZoomOut}
    >
      <svg
        width="20"
        height="3"
        viewBox="0 0 22 3"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22 3H0V0H22V3Z" fill={disableZoomOut ? theme.disabled : theme.buttons} />
      </svg>
    </button>
  </Ui.ZoomButton>
);

export default ZoomButton;
